module.exports = __webpack_public_path__ + "img/background-pos-detail.527d60b0.svg";